export default {
  en: {
    title: 'Link Yandex or VK',
    body: 'Progress, word lists and subscription from the bot — on all your devices.',
      },
  ru: {
    title: 'Привяжи Яндекс или VK',
    body: 'Прогресс, словари и подписка из бота — на всех твоих устройствах.',
      },
};
